import React from 'react'
import { Routes, Route } from 'react-router-dom'
import MainLayout from '../components/MainLayout'
import HomeSinglePage from '../pages/HomeSinglePage'
import JobDetail from '../pages/JobDetail'
import Team from '../pages/Team'
import TeamDetail from '../pages/TeamDetail'
import Careers from '../pages/Careers'
import Contact from '../pages/Contact'
import Resources from '../pages/Resources'
import Sitemap from '../pages/Sitemap'
import About from '../pages/About'
import Emdr from '../pages/Emdr'
import SlidingScale from '../pages/SlidingScale'
import Locations from '../pages/Locations'
import Groups from '../pages/Groups'
import ModalitiesRates from '../pages/ModalitiesRates'
import ServicesInvestment from '../pages/ServicesInvestment'
import Services from '../pages/Services'
import TherapyModality from '../pages/TherapyModality'
import IntakeForm from '../pages/IntakeForm'
import SmsPrivacyPolicy from '../pages/SmsPrivacyPolicy'
import SmsTerms from '../pages/SmsTerms'
import NotFound from '../pages/NotFound'

export default function MarketingRoutes() {
  return (
    <Routes>
<Route
                path="/"
                element={
                  <MainLayout>
                    <HomeSinglePage />
                  </MainLayout>
                }
              />
              <Route
                path="/en"
                element={
                  <MainLayout>
                    <HomeSinglePage />
                  </MainLayout>
                }
              />
              <Route
                path="/pt"
                element={
                  <MainLayout>
                    <HomeSinglePage />
                  </MainLayout>
                }
              />
              
              {/* About page */}
              <Route
                path="/about"
                element={
                  <MainLayout>
                    <About />
                  </MainLayout>
                }
              />
              <Route
                path="/en/about"
                element={
                  <MainLayout>
                    <About />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/about"
                element={
                  <MainLayout>
                    <About />
                  </MainLayout>
                }
              />
              <Route
                path="/emdr"
                element={
                  <MainLayout>
                    <Emdr />
                  </MainLayout>
                }
              />
              <Route
                path="/en/emdr"
                element={
                  <MainLayout>
                    <Emdr />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/emdr"
                element={
                  <MainLayout>
                    <Emdr />
                  </MainLayout>
                }
              />
              <Route
                path="/sliding-scale"
                element={
                  <MainLayout>
                    <SlidingScale />
                  </MainLayout>
                }
              />
              <Route
                path="/en/sliding-scale"
                element={
                  <MainLayout>
                    <SlidingScale />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/sliding-scale"
                element={
                  <MainLayout>
                    <SlidingScale />
                  </MainLayout>
                }
              />
              <Route
                path="/locations"
                element={
                  <MainLayout>
                    <Locations />
                  </MainLayout>
                }
              />
              <Route
                path="/en/locations"
                element={
                  <MainLayout>
                    <Locations />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/locations"
                element={
                  <MainLayout>
                    <Locations />
                  </MainLayout>
                }
              />
              <Route
                path="/groups"
                element={
                  <MainLayout>
                    <Groups />
                  </MainLayout>
                }
              />
              <Route
                path="/groups/:slug"
                element={
                  <MainLayout>
                    <Groups />
                  </MainLayout>
                }
              />
              <Route
                path="/en/groups"
                element={
                  <MainLayout>
                    <Groups />
                  </MainLayout>
                }
              />
              <Route
                path="/en/groups/:slug"
                element={
                  <MainLayout>
                    <Groups />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/groups"
                element={
                  <MainLayout>
                    <Groups />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/groups/:slug"
                element={
                  <MainLayout>
                    <Groups />
                  </MainLayout>
                }
              />
              <Route
                path="/modalities-rates"
                element={
                  <MainLayout>
                    <ModalitiesRates />
                  </MainLayout>
                }
              />
              <Route
                path="/en/modalities-rates"
                element={
                  <MainLayout>
                    <ModalitiesRates />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/modalities-rates"
                element={
                  <MainLayout>
                    <ModalitiesRates />
                  </MainLayout>
                }
              />
              <Route
                path="/services-investment"
                element={
                  <MainLayout>
                    <ServicesInvestment />
                  </MainLayout>
                }
              />
              <Route
                path="/en/services-investment"
                element={
                  <MainLayout>
                    <ServicesInvestment />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/services-investment"
                element={
                  <MainLayout>
                    <ServicesInvestment />
                  </MainLayout>
                }
              />
              <Route
                path="/services"
                element={
                  <MainLayout>
                    <Services />
                  </MainLayout>
                }
              />
              <Route
                path="/en/services"
                element={
                  <MainLayout>
                    <Services />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/services"
                element={
                  <MainLayout>
                    <Services />
                  </MainLayout>
                }
              />
              <Route
                path="/therapy-modality"
                element={
                  <MainLayout>
                    <TherapyModality />
                  </MainLayout>
                }
              />
              <Route
                path="/en/therapy-modality"
                element={
                  <MainLayout>
                    <TherapyModality />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/therapy-modality"
                element={
                  <MainLayout>
                    <TherapyModality />
                  </MainLayout>
                }
              />
              {/* Careers page */}
              <Route
                path="/careers"
                element={
                  <MainLayout>
                    <Careers />
                  </MainLayout>
                }
              />
              <Route
                path="/en/careers"
                element={
                  <MainLayout>
                    <Careers />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/careers"
                element={
                  <MainLayout>
                    <Careers />
                  </MainLayout>
                }
              />
              
              {/* Resources page */}
              <Route
                path="/resources"
                element={
                  <MainLayout>
                    <Resources />
                  </MainLayout>
                }
              />
              <Route
                path="/en/resources"
                element={
                  <MainLayout>
                    <Resources />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/resources"
                element={
                  <MainLayout>
                    <Resources />
                  </MainLayout>
                }
              />
              
              {/* Client intake form */}
              <Route
                path="/intake"
                element={
                  <MainLayout>
                    <IntakeForm />
                  </MainLayout>
                }
              />
              <Route
                path="/en/intake"
                element={
                  <MainLayout>
                    <IntakeForm />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/intake"
                element={
                  <MainLayout>
                    <IntakeForm />
                  </MainLayout>
                }
              />

              {/* SMS legal (Twilio A2P / consent disclosures) */}
              <Route
                path="/sms-privacy-policy"
                element={
                  <MainLayout>
                    <SmsPrivacyPolicy />
                  </MainLayout>
                }
              />
              <Route
                path="/en/sms-privacy-policy"
                element={
                  <MainLayout>
                    <SmsPrivacyPolicy />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/sms-privacy-policy"
                element={
                  <MainLayout>
                    <SmsPrivacyPolicy />
                  </MainLayout>
                }
              />
              <Route
                path="/sms-terms"
                element={
                  <MainLayout>
                    <SmsTerms />
                  </MainLayout>
                }
              />
              <Route
                path="/en/sms-terms"
                element={
                  <MainLayout>
                    <SmsTerms />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/sms-terms"
                element={
                  <MainLayout>
                    <SmsTerms />
                  </MainLayout>
                }
              />

              {/* Contact page */}
              <Route
                path="/contact"
                element={
                  <MainLayout>
                    <Contact />
                  </MainLayout>
                }
              />
              <Route
                path="/en/contact"
                element={
                  <MainLayout>
                    <Contact />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/contact"
                element={
                  <MainLayout>
                    <Contact />
                  </MainLayout>
                }
              />
              
              {/* Sitemap page */}
              <Route
                path="/sitemap"
                element={
                  <MainLayout>
                    <Sitemap />
                  </MainLayout>
                }
              />
              <Route
                path="/en/sitemap"
                element={
                  <MainLayout>
                    <Sitemap />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/sitemap"
                element={
                  <MainLayout>
                    <Sitemap />
                  </MainLayout>
                }
              />
              
              {/* Careers detail pages - still separate for job applications */}
              <Route
                path="/careers/:slug"
                element={
                  <MainLayout>
                    <JobDetail />
                  </MainLayout>
                }
              />
              <Route
                path="/en/careers/:slug"
                element={
                  <MainLayout>
                    <JobDetail />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/careers/:slug"
                element={
                  <MainLayout>
                    <JobDetail />
                  </MainLayout>
                }
              />
              
              {/* Team listing & detail */}
              <Route
                path="/team"
                element={
                  <MainLayout>
                    <Team />
                  </MainLayout>
                }
              />
              <Route
                path="/en/team"
                element={
                  <MainLayout>
                    <Team />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/team"
                element={
                  <MainLayout>
                    <Team />
                  </MainLayout>
                }
              />
              <Route
                path="/team/:slug"
                element={
                  <MainLayout>
                    <TeamDetail />
                  </MainLayout>
                }
              />
              <Route
                path="/en/team/:slug"
                element={
                  <MainLayout>
                    <TeamDetail />
                  </MainLayout>
                }
              />
              <Route
                path="/pt/team/:slug"
                element={
                  <MainLayout>
                    <TeamDetail />
                  </MainLayout>
                }
              />

              <Route
                path="*"
                element={
                  <MainLayout>
                    <NotFound />
                  </MainLayout>
                }
              />

    </Routes>
  )
}
